export default __webpack_public_path__ + "static/media/GetHelp_CreditBook.dbe5e84b.svg";